// General
export const CLEAR_ORGANIZATION_MESSAGES = 'CLEAR_ORGANIZATION_MESSAGES';

// Details
export const LOAD_ORGANIZATION_DETAILS = 'LOAD_ORGANIZATION_DETAILS';
export const LOAD_ORGANIZATION_DETAILS_SUCCESS = 'LOAD_ORGANIZATION_DETAILS_SUCCESS';
export const LOAD_ORGANIZATION_DETAILS_FAILED = 'LOAD_ORGANIZATION_DETAILS_FAILED';

export const EDIT_ORGANIZATION_DETAILS = 'EDIT_ORGANIZATION_DETAILS';
export const EDIT_ORGANIZATION_DETAILS_SUCCESS = 'EDIT_ORGANIZATION_DETAILS_SUCCESS';
export const EDIT_ORGANIZATION_DETAILS_FAILED = 'EDIT_ORGANIZATION_DETAILS_FAILED';

export const CREATE_ORGANIZATION = 'CREATE_ORGANIZATION';
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_FAILED = 'CREATE_ORGANIZATION_FAILED';

// Clients
export const LOAD_ORGANIZATION_CLIENTS = 'LOAD_ORGANIZATION_CLIENTS';
export const LOAD_ORGANIZATION_CLIENTS_SUCCESS = 'LOAD_ORGANIZATION_CLIENTS_SUCCESS';
export const LOAD_ORGANIZATION_CLIENTS_FAILED = 'LOAD_ORGANIZATION_CLIENTS_FAILED';

export const LOAD_ORGANIZATION_MAIN_CLIENT = 'LOAD_ORGANIZATION_MAIN_CLIENT';
export const LOAD_ORGANIZATION_MAIN_CLIENT_SUCCESS = 'LOAD_ORGANIZATION_MAIN_CLIENT_SUCCESS';
export const LOAD_ORGANIZATION_MAIN_CLIENT_FAILED = 'LOAD_ORGANIZATION_MAIN_CLIENT_FAILED';

export const SAVE_ORGANIZATION_MAIN_CLIENT = 'SAVE_ORGANIZATION_MAIN_CLIENT';
export const SAVE_ORGANIZATION_MAIN_CLIENT_SUCCESS = 'SAVE_ORGANIZATION_MAIN_CLIENT_SUCCESS';
export const SAVE_ORGANIZATION_MAIN_CLIENT_FAILED = 'SAVE_ORGANIZATION_MAIN_CLIENT_FAILED';

// Users
export const LOAD_ORGANIZATION_USERS = 'LOAD_ORGANIZATION_USERS';
export const LOAD_ORGANIZATION_USERS_SUCCESS = 'LOAD_ORGANIZATION_USERS_SUCCESS';
export const LOAD_ORGANIZATION_USERS_FAILED = 'LOAD_ORGANIZATION_USERS_FAILED';

export const INVITE_USER_TO_ORGANIZATION = 'INVITE_USER_TO_ORGANIZATION';
export const INVITE_USER_TO_ORGANIZATION_SUCCESS = 'INVITE_USER_TO_ORGANIZATION_SUCCESS';
export const INVITE_USER_TO_ORGANIZATION_FAILED = 'INVITE_USER_TO_ORGANIZATION_FAILED';

export const RESEND_ORGANIZATION_INVITATION = 'RESEND_ORGANIZATION_INVITATION';
export const RESEND_ORGANIZATION_INVITATION_SUCCESS = 'RESEND_ORGANIZATION_INVITATION_SUCCESS';
export const RESEND_ORGANIZATION_INVITATION_FAILED = 'RESEND_ORGANIZATION_INVITATION_FAILED';

export const CANCEL_ORGANIZATION_INVITATION = 'CANCEL_ORGANIZATION_INVITATION';
export const CANCEL_ORGANIZATION_INVITATION_SUCCESS = 'CANCEL_ORGANIZATION_INVITATION_SUCCESS';
export const CANCEL_ORGANIZATION_INVITATION_FAILED = 'CANCEL_ORGANIZATION_INVITATION_FAILED';

export const REMOVE_USER_MANAGER_FLAG = 'REMOVE_USER_MANAGER_FLAG';
export const REMOVE_USER_MANAGER_FLAG_SUCCESS = 'REMOVE_USER_MANAGER_FLAG_SUCCESS';
export const REMOVE_USER_MANAGER_FLAG_FAILED = 'REMOVE_USER_MANAGER_FLAG_FAILED';

export const MAKE_USER_MANAGER = 'MAKE_USER_MANAGER';
export const MAKE_USER_MANAGER_SUCCESS = 'MAKE_USER_MANAGER_SUCCESS';
export const MAKE_USER_MANAGER_FAILED = 'MAKE_USER_MANAGER_FAILED';

export const ASSOCIATE_LICENSE = 'ASSOCIATE_LICENSE';
export const ASSOCIATE_LICENSE_SUCCESS = 'ASSOCIATE_LICENSE_SUCCESS';
export const ASSOCIATE_LICENSE_FAILED = 'ASSOCIATE_LICENSE_FAILED';

export const CANCEL_LICENSE = 'CANCEL_LICENSE';
export const CANCEL_LICENSE_SUCCESS = 'CANCEL_LICENSE_SUCCESS';
export const CANCEL_LICENSE_FAILED = 'CANCEL_LICENSE_FAILED';

export const REMOVE_USER_FROM_ORGANIZATION = 'REMOVE_USER_FROM_ORGANIZATION';
export const REMOVE_USER_FROM_ORGANIZATION_SUCCESS = 'REMOVE_USER_FROM_ORGANIZATION_SUCCESS';
export const REMOVE_USER_FROM_ORGANIZATION_FAILED = 'REMOVE_USER_FROM_ORGANIZATION_FAILED';

// Dashboard
export const LOAD_ORGANIZATION_DASHBOARD_DATA = 'LOAD_ORGANIZATION_DASHBOARD_DATA';
export const LOAD_ORGANIZATION_DASHBOARD_DATA_SUCCESS = 'LOAD_ORGANIZATION_DASHBOARD_DATA_SUCCESS';
export const LOAD_ORGANIZATION_DASHBOARD_DATA_FAILED = 'LOAD_ORGANIZATION_DASHBOARD_DATA_FAILED';

// Value proposition
export const LOAD_ORGANIZATION_VALUE_PROPOSITIONS = 'LOAD_ORGANIZATION_VALUE_PROPOSITIONS';
export const LOAD_ORGANIZATION_VALUE_PROPOSITIONS_SUCCESS = 'LOAD_ORGANIZATION_VALUE_PROPOSITIONS_SUCCESS';
export const LOAD_ORGANIZATION_VALUE_PROPOSITIONS_FAILED = 'LOAD_ORGANIZATION_VALUE_PROPOSITIONS_FAILED';

export const GET_ORGANIZATION_VALUE_PROPOSITION_DETAILS = 'GET_ORGANIZATION_VALUE_PROPOSITION_DETAILS';
export const GET_ORGANIZATION_VALUE_PROPOSITION_DETAILS_SUCCESS =
  'GET_ORGANIZATION_VALUE_PROPOSITION_DETAILS_SUCCESS';
export const GET_ORGANIZATION_VALUE_PROPOSITION_DETAILS_FAILED =
  'GET_ORGANIZATION_VALUE_PROPOSITION_DETAILS_FAILED';

// Value proposition reassignment
export const REASSIGN_VALUE_PROPOSITION = 'REASSIGN_VALUE_PROPOSITION';
export const REASSIGN_VALUE_PROPOSITION_SUCCESS = 'REASSIGN_VALUE_PROPOSITION_SUCCESS';
export const REASSIGN_VALUE_PROPOSITION_FAILED = 'REASSIGN_VALUE_PROPOSITION_FAILED';

export const REASSIGN_VALUE_PROPOSITIONS = 'REASSIGN_VALUE_PROPOSITIONS';
export const REASSIGN_VALUE_PROPOSITIONS_SUCCESS = 'REASSIGN_VALUE_PROPOSITIONS_SUCCESS';
export const REASSIGN_VALUE_PROPOSITIONS_FAILED = 'REASSIGN_VALUE_PROPOSITIONS_FAILED';

export const CLEAR_REASSIGN_STATE = 'CLEAR_REASSIGN_STATE';

// Licenses
export const ORGANIZATION_UPGRADE_LICENSES = 'ORGANIZATION_UPGRADE_LICENSES';
export const ORGANIZATION_UPGRADE_LICENSES_SUCCESS = 'ORGANIZATION_UPGRADE_LICENSES_SUCCESS';
export const ORGANIZATION_UPGRADE_LICENSES_FAILED = 'ORGANIZATION_UPGRADE_LICENSES_FAILED';

export const ORGANIZATION_DOWNGRADE_LICENSES = 'ORGANIZATION_DOWNGRADE_LICENSES';
export const ORGANIZATION_DOWNGRADE_LICENSES_SUCCESS = 'ORGANIZATION_DOWNGRADE_LICENSES_SUCCESS';
export const ORGANIZATION_DOWNGRADE_LICENSES_FAILED = 'ORGANIZATION_DOWNGRADE_LICENSES_FAILED';

export const CHANGE_ORGANIZATION_USER_LICENSES = 'CHANGE_ORGANIZATION_USER_LICENSES';
export const CHANGE_ORGANIZATION_USER_LICENSES_SUCCESS = 'CHANGE_ORGANIZATION_USER_LICENSES_SUCCESS';
export const CHANGE_ORGANIZATION_USER_LICENSES_FAILED = 'CHANGE_ORGANIZATION_USER_LICENSES_FAILED';

export const ORGANIZATION_USER_LICENSE_SUCCESS_STRIPE = 'ORGANIZATION_USER_LICENSE_SUCCESS_STRIPE';
export const ORGANIZATION_USER_LICENSE_SUCCESS_STRIPE_SUCCESS =
  'ORGANIZATION_USER_LICENSE_SUCCESS_STRIPE_SUCCESS';
export const ORGANIZATION_USER_LICENSE_SUCCESS_STRIPE_FAILED =
  'ORGANIZATION_USER_LICENSE_SUCCESS_STRIPE_FAILED';

export const CLEAR_ORGANIZATION_USER_LICENSE = 'CLEAR_ORGANIZATION_USER_LICENSE';

// Invites
export const GET_MY_INVITATIONS = 'GET_MY_INVITATIONS';
export const GET_MY_INVITATIONS_SUCCESS = 'GET_MY_INVITATIONS_SUCCESS';
export const GET_MY_INVITATIONS_FAILED = 'GET_MY_INVITATIONS_FAILED';

export const ACCEPT_INVITATION = 'ACCEPT_INVITATION';
export const ACCEPT_INVITATION_SUCCESS = 'ACCEPT_INVITATION_SUCCESS';
export const ACCEPT_INVITATION_FAILED = 'ACCEPT_INVITATION_FAILED';

export const REJECT_INVITATION = 'REJECT_INVITATION';
export const REJECT_INVITATION_SUCCESS = 'REJECT_INVITATION_SUCCESS';
export const REJECT_INVITATION_FAILED = 'REJECT_INVITATION_FAILED';

export const ACCEPT_ORGANIZATION_INVITATION = 'ACCEPT_ORGANIZATION_INVITATION';
export const ACCEPT_ORGANIZATION_INVITATION_SUCCESS = 'ACCEPT_ORGANIZATION_INVITATION_SUCCESS';
export const ACCEPT_ORGANIZATION_INVITATION_FAILED = 'ACCEPT_ORGANIZATION_INVITATION_FAILED';

export const LOAD_ORGANIZATION_INVITATION_TOKEN_DETAILS =
  'LOAD_ORGANIZATION_INVITATION_TOKEN_DETAILS';
export const LOAD_ORGANIZATION_INVITATION_TOKEN_DETAILS_SUCCESS =
  'LOAD_ORGANIZATION_INVITATION_TOKEN_DETAILS_SUCCESS';
export const LOAD_ORGANIZATION_INVITATION_TOKEN_DETAILS_FAILED =
  'LOAD_ORGANIZATION_INVITATION_TOKEN_DETAILS_FAILED';

export const DECLINE_ORGANIZATION_INVITATION = 'DECLINE_ORGANIZATION_INVITATION';
export const DECLINE_ORGANIZATION_INVITATION_SUCCESS = 'DECLINE_ORGANIZATION_INVITATION_SUCCESS';
export const DECLINE_ORGANIZATION_INVITATION_FAILED = 'DECLINE_ORGANIZATION_INVITATION_FAILED';

// Owner and Transfer
export const CHECK_OWNER_AND_GET_MANAGERS = 'CHECK_OWNER_AND_GET_MANAGERS';
export const CHECK_OWNER_AND_GET_MANAGERS_SUCCESS = 'CHECK_OWNER_AND_GET_MANAGERS_SUCCESS';
export const CHECK_OWNER_AND_GET_MANAGERS_FAILED = 'CHECK_OWNER_AND_GET_MANAGERS_FAILED';

export const TRANSFER_OWNERSHIP = 'TRANSFER_OWNERSHIP';
export const TRANSFER_OWNERSHIP_SUCCESS = 'TRANSFER_OWNERSHIP_SUCCESS';
export const TRANSFER_OWNERSHIP_FAILED = 'TRANSFER_OWNERSHIP_FAILED';

export const DEACTIVATE_ORGANIZATION = 'DEACTIVATE_ORGANIZATION';
export const DEACTIVATE_ORGANIZATION_SUCCESS = 'DEACTIVATE_ORGANIZATION_SUCCESS';
export const DEACTIVATE_ORGANIZATION_FAILED = 'DEACTIVATE_ORGANIZATION_FAILED';

export const SEND_RECOVERY_CODE_EMAIL = 'SEND_RECOVERY_CODE_EMAIL';
export const SEND_RECOVERY_CODE_EMAIL_SUCCESS = 'SEND_RECOVERY_CODE_EMAIL_SUCCESS';
export const SEND_RECOVERY_CODE_EMAIL_FAILED = 'SEND_RECOVERY_CODE_EMAIL_FAILED';

export const GENERATE_RECOVERY_CODE_AFTER_UNSUBSCRIBE = 'GENERATE_RECOVERY_CODE_AFTER_UNSUBSCRIBE';
export const GENERATE_RECOVERY_CODE_AFTER_UNSUBSCRIBE_SUCCESS = 'GENERATE_RECOVERY_CODE_AFTER_UNSUBSCRIBE_SUCCESS';
export const GENERATE_RECOVERY_CODE_AFTER_UNSUBSCRIBE_FAILED = 'GENERATE_RECOVERY_CODE_AFTER_UNSUBSCRIBE_FAILED';

export const REACTIVATE_ORGANIZATION = 'REACTIVATE_ORGANIZATION';
export const REACTIVATE_ORGANIZATION_SUCCESS = 'REACTIVATE_ORGANIZATION_SUCCESS';
export const REACTIVATE_ORGANIZATION_FAILED = 'REACTIVATE_ORGANIZATION_FAILED';